class Layer {
    name;
    css;
    rules;
    tokenCounts;
    constructor(name, css){
        this.name = name;
        this.css = css;
        this.rules = [];
        this.tokenCounts = new Map();
    }
    attach() {
        this.css.rules.push(this);
    }
    detach() {
        this.css.rules.splice(this.css.rules.indexOf(this), 1);
    }
    insert(rule, index = this.rules.length) {
        if (this.rules.find(({ key })=>key === rule.key)) return;
        this.rules.splice(index, 0, rule);
        // should attach after inserting, because this.text is possibly empty
        if (!this.css.rules.includes(this)) {
            this.attach();
        }
        return index;
    }
    delete(key) {
        const index = this.rules.findIndex((rule)=>rule.key === key);
        if (index === -1) return;
        const deletedRule = this.rules[index];
        this.rules.splice(index, 1);
        if (this.rules.length === 0) {
            this.detach();
        }
        return deletedRule;
    }
    reset() {
        this.rules.length = 0;
        const indexOfLayer = this.css.rules.indexOf(this);
        if (indexOfLayer !== -1) {
            this.css.rules.splice(indexOfLayer, 1);
        }
        this.tokenCounts.clear();
    }
    get text() {
        const ruleText = this.rules.map(({ text })=>text).join('');
        if (!ruleText) return '';
        return '@layer ' + this.name + '{' + ruleText + '}';
    }
}

export { Layer as default };
